/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * The default organizational unit.
 * @export
 * @interface UserDefaultOrgUnit
 */
export interface UserDefaultOrgUnit {
    /**
     * Organizational unit identifier
     * @type {string}
     * @memberof UserDefaultOrgUnit
     */
    uid: string;
}

/**
 * Check if a given object implements the UserDefaultOrgUnit interface.
 */
export function instanceOfUserDefaultOrgUnit(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "uid" in value;

    return isInstance;
}

export function UserDefaultOrgUnitFromJSON(json: any): UserDefaultOrgUnit {
    return UserDefaultOrgUnitFromJSONTyped(json, false);
}

export function UserDefaultOrgUnitFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserDefaultOrgUnit {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'uid': json['uid'],
    };
}

export function UserDefaultOrgUnitToJSON(value?: UserDefaultOrgUnit | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'uid': value.uid,
    };
}

